import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import marketingModule, { setPageInfo, setRequestInfo } from './marketingModule';
import MarketingSnippets from './MarketingSnippets';
import sendToRaygun from './sendToRaygun';
import { loadCustomerDetails, loadMembership } from '@techstyle/react-accounts';
export default function marketingExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var getRequestInfo = _ref.getRequestInfo,
      googleTagManagerEvents = _ref.googleTagManagerEvents,
      segmentEvents = _ref.segmentEvents,
      referringPageCookieName = _ref.referringPageCookieName,
      reduxMiddlewares = _ref.reduxMiddlewares,
      snippets = _objectWithoutProperties(_ref, ["getRequestInfo", "googleTagManagerEvents", "segmentEvents", "referringPageCookieName", "reduxMiddlewares"]);

  return {
    id: 'marketing',
    server: process.browser ? undefined : {
      init: function init() {
        require('./config');
      }
    },
    redux: function redux(context) {
      var reduxConfig = {
        modules: [marketingModule]
      };
      var extension = {
        middleware: []
      };

      if (process.browser) {
        if (googleTagManagerEvents) {
          extension.middleware.push(googleTagManagerEvents);
        }

        if (segmentEvents) {
          extension.middleware.push(segmentEvents);
        }
      }

      var extraMiddleware = typeof reduxMiddlewares === 'function' ? reduxMiddlewares(context) : reduxMiddlewares;

      if (extraMiddleware && Array.isArray(extraMiddleware)) {
        extraMiddleware.forEach(function (middleware) {
          extension.middleware.push(middleware);
        });
      }

      if (extension.middleware.length) {
        reduxConfig.extensions = [extension];
      }

      return reduxConfig;
    },
    document: process.browser ? undefined : {
      getInitialProps: {
        enhance: function enhance(getInitialProps) {
          return /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
              var initialProps, beforeMain, beforeNextScript, afterNextScript, requestInfo;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return getInitialProps(ctx);

                    case 2:
                      initialProps = _context.sent;
                      beforeMain = snippets.beforeMain, beforeNextScript = snippets.beforeNextScript, afterNextScript = snippets.afterNextScript;
                      requestInfo = ctx.store.getState().marketing.requestInfo;

                      if (typeof beforeMain === 'function') {
                        beforeMain = beforeMain(requestInfo);
                      }

                      if (typeof beforeNextScript === 'function') {
                        beforeNextScript = beforeNextScript(requestInfo);
                      }

                      if (typeof afterNextScript === 'function') {
                        afterNextScript = afterNextScript(requestInfo);
                      }

                      if (beforeMain) {
                        initialProps.beforeMain.push(beforeMain);
                      }

                      if (beforeNextScript) {
                        initialProps.beforeNextScript.push(beforeNextScript);
                      }

                      if (afterNextScript) {
                        initialProps.afterNextScript.push(afterNextScript);
                      }

                      return _context.abrupt("return", initialProps);

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }();
        }
      }
    },
    app: {
      getInitialProps: {
        enhance: function enhance(getInitialProps) {
          return /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
              var Component, ctx, initialProps, _requestInfo, requestInfo;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      Component = _ref3.Component, ctx = _ref3.ctx;
                      ctx.sendToRaygun = sendToRaygun;

                      if (ctx.err) {
                        sendToRaygun(ctx.err);
                      }

                      _context2.prev = 3;
                      _context2.next = 6;
                      return getInitialProps({
                        Component: Component,
                        ctx: ctx
                      });

                    case 6:
                      initialProps = _context2.sent;

                    case 7:
                      _context2.prev = 7;

                      if (!(getRequestInfo && ctx.req)) {
                        _context2.next = 13;
                        break;
                      }

                      _context2.next = 11;
                      return getRequestInfo(ctx);

                    case 11:
                      _requestInfo = _context2.sent;
                      ctx.store.dispatch(setRequestInfo(_requestInfo));

                    case 13:
                      return _context2.finish(7);

                    case 14:
                      requestInfo = ctx.store.getState().marketing.requestInfo;
                      return _context2.abrupt("return", _objectSpread(_objectSpread({}, initialProps), {}, {
                        marketingRequestInfo: requestInfo
                      }));

                    case 16:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[3,, 7, 14]]);
            }));

            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }();
        }
      },
      render: function render(props, children) {
        // eslint-disable-next-line react/prop-types
        var requestInfo = props.marketingRequestInfo;
        return /*#__PURE__*/React.createElement(MarketingSnippets, {
          referringPageCookieName: referringPageCookieName,
          requestInfo: requestInfo,
          snippets: snippets
        }, children);
      }
    },
    page: function page(_ref5) {
      var inputMarketingInfo = _ref5.marketingInfo;
      return {
        getInitialProps: function getInitialProps(ctx) {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var marketingInfo, prefetchCustomerDetails;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(typeof inputMarketingInfo === 'function')) {
                      _context3.next = 6;
                      break;
                    }

                    _context3.next = 3;
                    return inputMarketingInfo(ctx);

                  case 3:
                    _context3.t0 = _context3.sent;
                    _context3.next = 7;
                    break;

                  case 6:
                    _context3.t0 = inputMarketingInfo;

                  case 7:
                    marketingInfo = _context3.t0;
                    ctx.store.dispatch(setPageInfo(marketingInfo)); // prefetching membership and customerDetail for segment's GTM dataLayer if server-side

                    if (!(segmentEvents && !process.browser)) {
                      _context3.next = 13;
                      break;
                    }

                    prefetchCustomerDetails = ['gender'];
                    _context3.next = 13;
                    return Promise.all([ctx.store.dispatch(loadMembership()), ctx.store.dispatch(loadCustomerDetails(prefetchCustomerDetails))]);

                  case 13:
                    return _context3.abrupt("return", {});

                  case 14:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))();
        }
      };
    }
  };
}